import { Heading, Paragraph } from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";
import { OppsummeringForm } from "../forms";
import { FormPage } from "./FormPage";

export const OppsummeringPage = () => {
  const { t } = useTranslation();
  return (
    <FormPage>
      <Heading data-size="md">{t("pages.oppsummering.tittel")}</Heading>
      <Paragraph data-size="lg" className="text-balder-text-subtle">
        {t("pages.oppsummering.beskrivelse")}
      </Paragraph>

      <OppsummeringForm />
    </FormPage>
  );
};
